import { render, staticRenderFns } from "./UpcomingPayment.vue?vue&type=template&id=0b6cd332"
import script from "./UpcomingPayment.vue?vue&type=script&lang=js"
export * from "./UpcomingPayment.vue?vue&type=script&lang=js"
import style0 from "./UpcomingPayment.vue?vue&type=style&index=0&id=0b6cd332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports